import { List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { Link } from '@remix-run/react';

const devTools = [
  {
    name: 'LGH Support Tools',
    description: 'Tools for LGH Support staff',
    path: '/admin/dev-tools/lgh-support',
  },
  {
    name: 'Project Admin Tools',
    description: 'Tools for Project admins',
    path: '/admin/dev-tools/project-admin',
  },
  {
    name: 'Group Admin Tools',
    description: 'Tools for Group admins',
    path: '/admin/dev-tools/group-admin',
  },
  {
    name: 'Participant Shared Password',
    description: 'View and set the shared password for participants',
    path: '/admin/dev-tools/shared-password',
  },
  {
    name: 'Reset Two-Factor Authentication',
    description: 'Reset two-factor authentication for a user',
    path: '/admin/dev-tools/reset-tfa',
  },
  {
    name: 'Sites',
    description: 'View and create sites',
    path: '/admin/dev-tools/sites',
  },
];

export default function DevToolsHomepage() {
  return (
    <Paper sx={{ maxWidth: 600, mx: 'auto', mt: 4, p: 3 }}>
      <Typography variant="header-xl" gutterBottom>
        Development Tools
      </Typography>

      <List>
        {devTools.map((tool) => (
          <ListItem
            key={tool.path}
            component={Link}
            to={tool.path}
            sx={{
              borderRadius: 1,
              '&:hover': {
                bgcolor: 'action.hover',
              },
            }}
          >
            <ListItemText primary={tool.name} secondary={tool.description} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
